module.exports = "img/8.4e59b3.jpg";